import { ListPatientsParams, PatientItem } from 'domain/usecases/list-patients'
import { Report } from 'domain/usecases/get-report'
import { atom } from 'recoil'

type DashboardAtomState = {
  isLoadingPatients: boolean | null
  isLoadingReports: boolean | null
  patients: PatientItem[]
  reports: Report[]
  pageOptions: {
    current: number | null
    size: number | null
    quantity: number | null
  }
}

export const dashboardAtom = atom<DashboardAtomState>({
  key: 'dashboardAtomState',
  default: {
    isLoadingPatients: null,
    isLoadingReports: null,
    patients: [],
    reports: [],
    pageOptions: {
      current: null,
      size: null,
      quantity: null,
    },
  },
})

export const dashboardFilterAtom = atom<ListPatientsParams>({
  key: 'dashboardFilterAtom',
  default: {
    name: '',
    search: '',
    status: [],
    treatment: [],
    cancer_type: [],
    genomic_variant: [],
    oncologist_id: '',
    order_by: {
      field: 'changed',
      order: 'DESC',
    },
    report_status: [],
    size: 10,
    page: 1,
  },
})
